import React, { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";

import TextField from "@material-ui/core/TextField";
import CircularProgress from "@material-ui/core/CircularProgress";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";

import { updateCountryList } from "../../store/actions/appdata";

const useStyles = makeStyles((theme) => ({
  option: {
    fontSize: 15,
    "& > span": {
      marginRight: 10,
      fontSize: 18,
    },
  },
}));

// ISO 3166-1 alpha-2
// ⚠️ No support for IE 11
function countryToFlag(isoCode) {
  return typeof String.fromCodePoint !== "undefined"
    ? isoCode
        .toUpperCase()
        .replace(/./g, (char) =>
          String.fromCodePoint(char.charCodeAt(0) + 127397)
        )
    : isoCode;
}

export default function CountrySelector({ onChange, ...rest }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const countryList = useSelector((state) =>
    !!state.appdata.country.list ? state.appdata.country.list : []
  );
  const loadingCountry = countryList.length === 0;

  useEffect(() => {
    if (countryList.length === 0) {
      dispatch(updateCountryList());
    }
  }, [countryList, dispatch]);

  return (
    <Autocomplete
      id="country-dropdown"
      options={countryList}
      classes={{
        option: classes.option,
      }}
      onChange={onChange}
      autoHighlight
      loading={loadingCountry}
      getOptionLabel={(option) => option.name}
      renderOption={(option) => (
        <Fragment>
          <span>{option.isoCode && countryToFlag(option.isoCode)}</span>
          {option.name}
        </Fragment>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Select a country"
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <Fragment>
                {loadingCountry ? (
                  <CircularProgress color="inherit" size={20} />
                ) : null}
                {params.InputProps.endAdornment}
              </Fragment>
            ),
            autoComplete: "new-password", // disable autocomplete and autofill
          }}
        />
      )}
      {...rest}
    />
  );
}
